<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>


<script>
let CONSTANT = require("../src/constant/constant.js"),
  common = require("../src/common.js");
export default {
  name: "app",
  data() {
    return {
      info:''
    };
  },
  created(){},
  mounted() {
    let path = this.$router.history.current.fullPath
    let arr = ['/','/serviceCenter','/serviceDetail',
      '/activityCenter','/newsCenter','/newsDetail','/organzation',
      '/tipsCenter','/tipsDetail','/about','/aboutDetail','/login','/register']
    if(arr.includes(path)) return
    this.getInfo()
  },
  methods:{
    getInfo(){
      let url = CONSTANT.URL.ADMIN.userCore
      common.get(url,'',(res)=>{
        if(res.status == 200){
          this.info = res.data.bussData
          common.setCookie('objectParam',JSON.stringify(res.data.bussData))
        }
      })
    },
  }
};
</script>

<style  lang="scss">
html {
  height: 100%;
  font-family:PingFang-SC-Regular;
  font-weight:400;
  background-color: #fff;
  font-size: 14px;
}

body {
  height: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}

#app {
  position: relative;
  height: 100%;
  width: 100%;
}

a {
  text-decoration: none;
}

ul,
li {
  box-sizing: content-box !important;
}

.content{
  width: 1226px;
  margin: 0 auto;
}

//公共
.box {
  display: -webkit-box;
  display: box;
  display: -moz-box;
  /* 老版本 - 适配iOS 6-, Safari 3.1-6 */
  display: -webkit-flex;
  /* 新版本 - 适配Chrome */
  display: flex;
}

.flex-column{
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -moz-box-orient: vertical;
  -moz-box-direction: normal;
  flex-direction: column;
}

.box-pack-center {
  -webkit-box-justify-content:  center;
  -moz-align-justify-content:  center;
  -webkit-align-justify-content: center;
  justify-content:  center;
}

.box-pack-start {
  -webkit-box-justify-content:  flex-start;
  -moz-align-justify-content:  flex-start;
  -webkit-align-justify-content:  flex-start;
  justify-content:  flex-start;
}

.box-pack-end {
  -webkit-box-justify-content:  flex-end;
  -moz-align-justify-content:  flex-end;
  -webkit-align-justify-content:  flex-end;
  justify-content:  flex-end;
}

.box-pack-between {
  -webkit-box-justify-content: space-between;
  -moz-align-justify-content: space-between;
  -webkit-align-justify-content: space-between;
  justify-content: space-between;
}

.box-pack-around {
  -webkit-box-justify-content: space-around;
  -moz-align-justify-content: space-around;
  -webkit-align-justify-content: space-around;
  justify-content: space-around;
}

.box-align-center {
    -webkit-box-align: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  align-items: center;
}

.box-align-start {
  -webkit-box-align: flex-start;
  -moz-align-items: flex-start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
}

.box-align-end {
   -webkit-box-align: flex-end;
  -moz-align-items: flex-end;
  -webkit-align-items: flex-end;
  align-items: flex-end;
}

.over-hidden{
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}

.flex1{
  flex: 1;
  -webkit-box-flex: 1;
}

</style>



// WEBPACK FOOTER //
// src/App.vue